import Provider from './navigation';
import './App.css';

export default function App() {
  return <Provider />;
}
